const USER_TYPES = {
  SUPER_ADMIN: -4,
  ACCOUNT_MANAGER: -3,
  OWNER: -2,
  KITCHEN_USER: -1,
  KITCHEN_SUPERVISOR: 0,
  KITCHEN_RUNNER: 1,
  KITCHEN_WAITER: 2,
  BRANCH_ADMIN: 3,
  CASHIER: 4,
  Driver: 5,
  AUDITOR: 6,
}

export default USER_TYPES
